/**
 * @license
 * Copyright (c) 2017, Absa Group Limited, All Rights Reserved.
 */

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import * as thresholdActions from '../../store/actions/actions';

declare var window: any;

@Component({
	selector: 'celine-threshold-session-expired',
	styles: [`
		.session-expired-container h4 {			
			font-size: 30px;			
			color: #515151;
			font-weight: 300;
			margin-top: 20px;
			margin-bottom: 15px;
		}

		.session-expired-container p {			
			font-size: 12px;
			color: #999;
			font-weight: 300;
		}

		.session-expired-container .btn-refresh {
			background: #f3f3f3;
			border: 0;
			display: inline-block;
			padding: 5px 15px;
			cursor: pointer;
			box-shadow: 0px 1px 2px #ccc;
			border-radius: 5px;
			margin-top: 15px;
		}

		.session-expired-container .btn-refresh svg {
			float: left;
			margin: 5px;
			
		}

		.session-expired-container .btn-refresh:hover svg {
			animation: lds-dual-ring 2.0s linear infinite;
		}

		.session-expired-container .btn-refresh span {
			float: left;
			margin: 7px;
			font-size: 12px;
			color: #999;
			font-weight: 300;		
		}

		.session-expired-container .btn-refresh:hover span {
			color: #000;
		}

		@keyframes lds-dual-ring {
			0% { transform: rotate(0deg); }
			100% { transform: rotate(360deg); }
		}

	`],
	template: `	
		<div class="session-expired-container container mt-5 mb-5">
			<div class="row justify-content-center">
				<div class="col-xs-6 col-sm-6 text-center">
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="45" height="45" viewBox="0 0 24 24">
						<defs><path id="a" d="M12.683 17.732c.087-.1.154-.209.202-.328a1.02 1.02 0 0 0 .077-.378c0-.26-.106-.518-.279-.707-.355-.368-1.009-.368-1.364 0a1.019 1.019 0 0 0-.279.707c0 .129.02.258.067.378.049.12.125.228.212.328a.938.938 0 0 0 .682.289c.26 0 .5-.1.682-.289zm.279-4.865V8.174C12.962 7.526 12.532 7 12 7c-.531 0-.96.526-.96 1.174v4.693c0 .65.429 1.174.96 1.174.531 0 .96-.525.96-1.174zm-1.78-8.4L3.042 18.532c-.12.216-.153.484-.087.741a.98.98 0 0 0 .447.603.947.947 0 0 0 .471.134H20.14a.931.931 0 0 0 .665-.3 1.021 1.021 0 0 0 .146-1.193L12.82 4.465a.944.944 0 0 0-1.639.003zM3.861 22a2.83 2.83 0 0 1-1.42-.4A2.952 2.952 0 0 1 1.1 19.788c-.2-.77-.098-1.574.287-2.265L9.535 3.441c0-.002 0-.003.002-.005a2.95 2.95 0 0 1 .969-1.004c1.358-.854 3.135-.402 3.959 1.004l8.14 14.073c.257.459.39.965.395 1.476.018 1.642-1.26 2.996-2.85 3.015H3.863z"/></defs>
						<g fill="none" fill-rule="evenodd"><path d="M0 24h23.997V0H0z"/><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><use fill="#000" xlink:href="#a"/><g fill="#dc630a" mask="url(#b)"><path d="M0 0h24v24H0z"/></g></g>
					</svg>

					<h4 *ngIf="!featTogLocalization">Please refresh your session</h4>
					<h4 *ngIf="featTogLocalization">{{ 'CELINE_ERROR_OCCURRED_REFRESHING_TOKEN' | translate }}</h4>
					
					<button class="btn-refresh" (click)="btnRefresh()">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25" viewBox="0 0 25 25">
							<defs><path id="aa" d="M23.97 10.153c.008-.05.03-.097.03-.15v-6a1 1 0 1 0-2 0v3.688l-2.932-2.755a10.079 10.079 0 0 0-3.737-2.358 9.937 9.937 0 0 0-7.643.403 9.933 9.933 0 0 0-5.12 5.688.999.999 0 1 0 1.885.667 7.945 7.945 0 0 1 4.097-4.55 7.95 7.95 0 0 1 6.113-.322 8.08 8.08 0 0 1 3.013 1.907l2.8 2.633H17a1 1 0 1 0 0 2h6c.139 0 .27-.03.39-.08l.014-.008a1.01 1.01 0 0 0 .313-.22c.003-.002.008-.003.012-.008.033-.035.046-.079.072-.118.047-.063.096-.126.125-.202.028-.069.033-.142.044-.215m-2.537 5.183a10.054 10.054 0 0 1-2.358 3.737 9.966 9.966 0 0 1-7.068 2.922 9.966 9.966 0 0 1-7.073-2.925L2 16.314v3.69a1 1 0 1 1-2 0v-6c0-.05.022-.095.029-.143.01-.075.016-.152.045-.225.03-.076.08-.138.128-.205.026-.036.039-.08.07-.112.003-.005.008-.006.01-.009.06-.06.135-.103.208-.146.04-.025.073-.06.114-.078.039-.017.084-.017.125-.029.085-.024.169-.05.257-.05.005 0 .009-.003.014-.003h6a1 1 0 1 1 0 2H3.525l2.8 2.63A7.966 7.966 0 0 0 12.004 20h.003a7.943 7.943 0 0 0 5.654-2.34 8.057 8.057 0 0 0 1.887-2.99.999.999 0 1 1 1.885.666"/></defs><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><mask id="bb" fill="#fff"><use xlink:href="#aa"/></mask><use fill="#000" xlink:href="#aa"/><g fill="#555" mask="url(#bb)"><path d="M0 0h24v24H0z"/></g></g>
						</svg>
						<span>Click here to log in again</span>
					</button>
					
				</div>
			</div>
		</div>		
	`
})

export class SessionExpiredComponent implements OnInit {

	private oidc: any;
	private featTogLocalization = process.env.config.feature.localization.enabled;

	/**
	 * 
	 * @param store 
	 */
	constructor(private store: Store<any>, private router: Router) {
      // Get oidc from the Window object
		this.oidc = window._oidc;

		ineum('reportEvent', '@celine: An error has occurred refreshing your token');

		setTimeout(() => {
			this.store.dispatch( new thresholdActions.SetBannerTitleAction('Session') );
			this.store.dispatch( new thresholdActions.SetApplicationTitleAction("Access") );
			this.store.dispatch( new thresholdActions.ShowBannerAction() );
			this.store.dispatch( new thresholdActions.SetColorAction('#fff') );
			this.store.dispatch( new thresholdActions.SetVariantAction('jumbo-variant-dark') );
			this.store.dispatch( new thresholdActions.SetBannerBackgroundAction('') );
			this.store.dispatch( new thresholdActions.SetSizeAction('sol-jumbo-h1') );
			this.store.dispatch( new thresholdActions.HideContextNavAction() );
			this.store.dispatch( new thresholdActions.HideMenuAction() );
			this.store.dispatch( new thresholdActions.HideMainMenuAction() );
			this.store.dispatch( new thresholdActions.HideProfileBannerAction() );
			this.store.dispatch( new thresholdActions.SetDynamicMenuAction([]));
			this.store.dispatch( new thresholdActions.HideHeaderMastheadAction());
		});
   }

	/**
	 * 
	 */
	ngOnInit(): void {
		sessionStorage.removeItem('authorizationDataIdToken');
		sessionStorage.removeItem('authorizationData');
		sessionStorage.removeItem('doNotShowMobileModalThisSession');
	}

	/**
	 * 
	 */
	btnRefresh() {		
		if (this.oidc) {
			this.oidc.removeUser();			
			document.location.href="/";
		}
		else {
			document.location.href="/";
		}
	}

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/session-expired/session-expired.component.ts